import { Col, Row, Flex } from 'antd';
import { useEffect } from 'react';
/**
 *
 * @returns
 */
export const BasePdfContainer = ({ addr_info, height = undefined, width = undefined, borderColor = undefined, backgroundColor = undefined, backgroundImg = '', children, marginTop = true, marginRight = true, marginBottom = true, marginLeft = true, scroll = undefined, minHeight = undefined}) => {
  let style = {
    height: height || '',
    width: width || '',
  };

  if (borderColor) {
    // style = { ...style, border: `1px solid ${borderColor}` };
  }
  if (backgroundColor) {
    style = { ...style, backgroundColor };
  }
  if (backgroundImg) {
    style = { ...style, background: `url(${backgroundImg}) 50% 50% / contain no-repeat` };
  }
  if (!marginTop) {
    style = { ...style, marginTop: '0px' };
  }
  if (!marginRight) {
    style = { ...style, marginRight: '0px' };
  }
  if (!marginBottom) {
    style = { ...style, marginBottom: '0px' };
  }
  if (!marginLeft) {
    style = { ...style, marginLeft: '0px' };
  }
  if (scroll) {
    style = { ...style, ...scroll };
  }
  if (minHeight) {
    style = { ...style, minHeight: minHeight };
  }
  // if (alignItems) {
  //   style = { ...style, alignItems: `${alignItems} !important` };
  // }

  return (
    <div className={`component-container-pdf`} style={{ ...style }}>
      <Flex justify={'space-between'} className='pdf_info'>
              <div>주문 상세 큐미르</div>
              <Flex gap={'small'} className='pdf_info_highlight'>
                  <div>주문번호 : {addr_info?.ORDER_IDX}</div>
                  <div>|</div>
                  <div>주문교육원 : {`${addr_info?.SCHOOL_NAME} (${addr_info?.SCHOOL_ID})`}</div>
              </Flex>
      </Flex>
      <div className='component-inner-container-pdf'>
        {children}
      </div>
    </div>
  );
};
